import type { IconSvgObject } from './types';

const TanIcon: IconSvgObject = [
  ["path", { d: "M7.5 17L8.7 13M14.5 17L13.3 13M8.7 13L10.5 7H11.5L13.3 13M8.7 13H13.3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 7V17L17 7V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 7H4.5M7 7H4.5M4.5 17V7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default TanIcon;
